const allchargeheaddata = { data: [], loading: true };
const alladdchargeheadpopulate = { data: [], loading: true };

export const GetAllChargeHeadRed = (state = allchargeheaddata, action) => {
  switch (action.type) {
    case "get_chargeheaddata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAddChargeHeadPopulateRed = (state = alladdchargeheadpopulate, action) => {
  switch (action.type) {
    case "get_addchargeheadpopulate":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
